// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"67":"91371a31","416":"fdffde42","534":"2222b2be"}[chunkId] + ".css";
};